import script from "./ScoreLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreLevel.vue?vue&type=script&setup=true&lang=js"

import "./ScoreLevel.vue?vue&type=style&index=0&id=29bae614&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bae614"]])

export default __exports__